// extracted by mini-css-extract-plugin
export default {"font-renta":"FormsData_font-renta__Z147Q"};